import ComponentSelector from '../../application-core/ComponentSelector';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AttachmentIcon from '@material-ui/icons/Attachment';
import Associations from '../Associations';
import { ProjectConsumer } from '../providers/ProjectProvider';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import IRIgeneration from '../../core/IRIgeneration';
import SlashHash from '../../core/SlashHash';
import GS from '../../grafsync/grafsync';
import ImportStepper from '../ImportStepper';
import { globalStyles } from '../style/gstheme';
import { getGraphFromProject, makeCancelable } from '../utils/utils';
import Warning from '../Warning';
import SelectFile from './SelectFile';
import SheetPreview from '../spreadsheet/SheetPreview';
import Upload from './Upload';
import MinorIssues from '../MinorIssues';
import MissingImports from '../MissingImports';
import ImportApproach from '../ImportApproach';
import TitledPanel from '../TitledPanel';

const styles = theme => {
    return Object.assign({
        importOuter: {
            backgroundColor: theme.palette.grey[100],
            marginBottom: '10px',
            borderRadius: '4px',
            textAlign: 'center',
            padding: '18px',
            minHeight: '250px',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        showFile: {
            backgroundColor: theme.palette.grey[200],
            fontWeight: 500,
            borderRadius: '6px',
            color: theme.palette.primary.main,
            padding: '10px'
        },
        importInner: {
            border: 'solid 1px ' + theme.palette.grey[500],
            backgroundColor: theme.palette.grey[100],
            borderRadius: '4px',
            textAlign: 'center',
            paddingTop: 30,
            minHeight: '200px',
            paddingBottom: 20
        }
    }, globalStyles);
};

const steps = ['Select File', 'Options', 'Upload'];

class SelectOptions extends React.Component {

    toggleMinorIssues = (event) => {
        const t = event.target;
        this.props.onToggleMinorIssues(t.value === "true");
    };

    toggleMissingImports = (event) => {
        const t = event.target;
        this.props.onToggleMissingImports(t.value);
    };

    toggleImportApproach = (event) => {
        const t = event.target;
        this.props.onToggleImportApproach(t.value);
    };

    handleSlashHashChange = event => {
        const t = event.target;
        this.props.onSlashHashSelect(t.value);
    };

    handleFormatChange = event => {
        const t = event.target;
        this.props.onIRIformatSelect(t.value);
    };

    handlePrimaryChange = (event) => {
        const t = event.target;
        this.props.onPrimaryCounterSet(Number(t.value));
    };

    handleSecondaryChange = (event) => {
        const t = event.target;
        this.props.onSecondaryCounterSet(Number(t.value));
    };

    updateMapping = (updatedMapping, updatedSpreadsheetOptions, validSpreadsheet) => {
        this.props.onUpdateMapping(updatedMapping, updatedSpreadsheetOptions, validSpreadsheet);
    };

    handleComponentChange = component => {
        this.props.onComponentSelect(component);
    };

    render() {

        const { iriType, iriFormat, isSpreadsheet, file, project, optionForXL, spreadsheetOptions, filename, existingComponents,
            includeOptions, limits, ontologyProjectAssociation, allowMinorIssues, importApproach, ignoreMissingImports, enabledImportInto, byIRI, allowCounter, primaryCounter, secondaryCounter,
            issueManagement, importManagement, importApproachManagement, configOptions, xrefComponents, component, maxRows } = this.props;

        const componentList = existingComponents ? existingComponents.map(t => t.id) : [];

        return (
            <ProjectConsumer>
                {({ defaultLang, projectLang }) => (
                    <div style={{ marginBottom: 20 }}>
                        <div className={this.props.classes.importOuter}>
                            <div className={this.props.classes.importInner}
                                style={{
                                    paddingTop: 0,
                                    textAlign: 'left',
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    paddingBottom: 20
                                }}>
                                {!isSpreadsheet ?
                                    <Grid container spacing={1}>
                                        {enabledImportInto && componentList && componentList.length > 0 &&
                                            <Grid item xs={12}>
                                                <TitledPanel margin={true} title="Dataset Management">
                                                    <ComponentSelector
                                                        id={project}
                                                        title="Import into Dataset"
                                                        allTitle="Import as is"
                                                        defaultLang={defaultLang}
                                                        components={componentList}
                                                        disabled={false}
                                                        graph={getGraphFromProject(project)}
                                                        handleChange={this.handleComponentChange} />
                                                </TitledPanel>
                                            </Grid>
                                        }
                                        {(!enabledImportInto || !componentList || componentList.length === 0 || component === undefined || component === "All") &&
                                            <React.Fragment>
                                                <Grid item xs={5}>
                                                    <SlashHash margin={!enabledImportInto || !componentList || componentList.length === 0} onChange={this.handleSlashHashChange} iriType={iriType} />
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <IRIgeneration
                                                        allowCounter={allowCounter}
                                                        margin={!enabledImportInto || !componentList || componentList.length === 0}
                                                        onChange={this.handleFormatChange}
                                                        primaryCounter={primaryCounter}
                                                        handlePrimaryChange={this.handlePrimaryChange}
                                                        handleSecondaryChange={this.handleSecondaryChange}
                                                        secondaryCounter={secondaryCounter}
                                                        showSecondaryCounter={optionForXL}
                                                        showCounters={iriFormat === "Counter"}
                                                        iriFormat={iriFormat} />
                                                </Grid>
                                            </React.Fragment>
                                        }
                                        {issueManagement &&
                                            <Grid item xs={5}>
                                                <MinorIssues
                                                    onChange={this.toggleMinorIssues}
                                                    margin={false}
                                                    allowMinorIssues={allowMinorIssues} />
                                            </Grid>
                                        }
                                        {importApproachManagement &&
                                            <Grid item xs={7}>
                                                <ImportApproach
                                                    onChange={this.toggleImportApproach}
                                                    margin={false}
                                                    approach={importApproach} />
                                            </Grid>
                                        }
                                        {importManagement &&
                                            <Grid item xs={12}>
                                                <MissingImports
                                                    onChange={this.toggleMissingImports}
                                                    margin={false}
                                                    ignoreMissingImports={ignoreMissingImports} />
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    ontologyProjectAssociation ?
                                        <Associations
                                            graph={getGraphFromProject(project)}
                                            onLoad={this.onLoadAssociations}
                                            ontologyProjectAssociation={ontologyProjectAssociation}
                                            component={SheetPreview}
                                            id={project}
                                            file={file}
                                            byIRI={byIRI}
                                            projectLang={projectLang}
                                            configOptions={configOptions}
                                            project={project}
                                            xrefComponents={xrefComponents}
                                            existingComponents={existingComponents}
                                            initialSettings={{
                                                ignoreHeaderRow: spreadsheetOptions.ignoreHeaderRow,
                                                ignoreInvalidValues: spreadsheetOptions.ignoreInvalidValues,
                                                removeSpaces: spreadsheetOptions.removeSpaces,
                                                replaceSpaces: spreadsheetOptions.replaceSpaces,
                                                removeSpecialCharacters: spreadsheetOptions.removeSpecialCharacters,
                                                replaceSpecialCharacters: spreadsheetOptions.replaceSpecialCharacters,
                                                minimiseEncoding: spreadsheetOptions.minimiseEncoding,
                                                prependText: spreadsheetOptions.prependText,
                                                appendText: spreadsheetOptions.appendText,
                                                codepage: spreadsheetOptions.codepage,
                                                useXL: spreadsheetOptions.useXL,
                                                title: spreadsheetOptions.title,
                                                baseIRI: spreadsheetOptions.baseIRI,
                                                defaultLang: spreadsheetOptions.lang,
                                                mapping: this.props.mapping !== undefined && this.props.mapping.length > 0 ? this.props.mapping : null
                                            }}
                                            iriType={iriType}
                                            limits={limits}
                                            includeOptions={includeOptions}
                                            iriFormat={iriFormat}
                                            optionForXL={optionForXL}
                                            onSlashHashChange={this.handleSlashHashChange}
                                            onFormatChange={this.handleFormatChange}
                                            onPrimaryChange={this.handlePrimaryChange}
                                            onSecondaryChange={this.handleSecondaryChange}
                                            defaultLang={defaultLang}
                                            onUpdateMapping={this.updateMapping}
                                        />
                                        :
                                        <SheetPreview
                                            file={file}
                                            project={project}
                                            iriType={iriType}
                                            limits={limits}
                                            maxRows={maxRows}
                                            byIRI={byIRI}
                                            projectLang={projectLang}
                                            xrefComponents={xrefComponents}
                                            existingComponents={existingComponents}
                                            configOptions={configOptions}
                                            initialSettings={{
                                                ignoreHeaderRow: spreadsheetOptions.ignoreHeaderRow,
                                                ignoreInvalidValues: spreadsheetOptions.ignoreInvalidValues,
                                                removeSpaces: spreadsheetOptions.removeSpaces,
                                                replaceSpaces: spreadsheetOptions.replaceSpaces,
                                                removeSpecialCharacters: spreadsheetOptions.removeSpecialCharacters,
                                                replaceSpecialCharacters: spreadsheetOptions.replaceSpecialCharacters,
                                                minimiseEncoding: spreadsheetOptions.minimiseEncoding,
                                                prependText: spreadsheetOptions.prependText,
                                                appendText: spreadsheetOptions.appendText,
                                                codepage: spreadsheetOptions.codepage,
                                                useXL: spreadsheetOptions.useXL,
                                                title: spreadsheetOptions.title,
                                                baseIRI: spreadsheetOptions.baseIRI,
                                                defaultLang: spreadsheetOptions.lang,
                                                mapping: this.props.mapping !== undefined && this.props.mapping.length > 0 ? this.props.mapping : null
                                            }}
                                            includeOptions={includeOptions}
                                            iriFormat={iriFormat}
                                            primaryCounter={primaryCounter}
                                            secondaryCounter={secondaryCounter}
                                            optionForXL={optionForXL}
                                            onSlashHashChange={this.handleSlashHashChange}
                                            onFormatChange={this.handleFormatChange}
                                            onPrimaryChange={this.handlePrimaryChange}
                                            onSecondaryChange={this.handleSecondaryChange}
                                            defaultLang={defaultLang}
                                            onUpdateMapping={this.updateMapping} />
                                }
                            </div>
                        </div>
                        {!isSpreadsheet && filename &&
                            <Typography data-test="attached-file" className={this.props.classes.showFile} paragraph>
                                <AttachmentIcon style={{ verticalAlign: 'bottom', marginRight: '10px' }} />
                                {filename}
                            </Typography>
                        }

                    </div>
                )}
            </ProjectConsumer>
        );
    }
}

const stateReset = {
    filename: null,
    started: false,
    file: null,
    normalisation: null,
    message: null,
    uuid: null,
    component: undefined,
    uploaded: false,
    isErrored: false,
    isSpreadsheet: false,
    completionMessage: false,
    baseIRI: "",
    sheetData: null,
    mapping: [],
    transfer: null,
    status: null,
    allowMinorIssues: true,
    importApproach: "Namespace",
    ignoreMissingImports: "undefined",
    slashHash: "Slash",
    iriFormat: "UUID",
    primaryCounter: 1,
    secondaryCounter: 10000000,
    validSpreadsheet: false,
    spreadsheetOptions: {},
    errorMessage: null
};

class ProjectImport extends React.Component {

    constructor(props) {
        super(props);
        this.state = Object.assign(stateReset, {});
        this.cancellable = null;
        this.clickRef = React.createRef();
    }

    componentWillUnmount() {
        if (this.hcTimeout) clearTimeout(this.hcTimeout);
        if (this.cancellable) this.cancellable.cancel();
    }

    onToggleMinorIssues = (allowMinorIssues) => this.setState({ allowMinorIssues });

    onToggleImportApproach = (importApproach) => this.setState({ importApproach });

    onToggleMissingImports = (ignoreMissingImports) => this.setState({ ignoreMissingImports });

    onSlashHashSelect = (slashHash) => this.setState({ slashHash });

    onIRIformatSelect = (iriFormat) => this.setState({ iriFormat });

    onPrimaryCounterSet = (primaryCounter) => this.setState({ primaryCounter });

    onSecondaryCounterSet = (secondaryCounter) => this.setState({ secondaryCounter });

    onComponentSelect = (value) => {
        const component = value === "All" ? undefined : value;
        this.setState({ component });
    };

    onUpdateMapping = (updatedMapping, updatedSpreadsheetOptions, validSpreadsheet) => {
        const mapping = [...updatedMapping];
        // For the second option many of the values come from existing settings of component
        // So we don't override them or update them
        const spreadsheetOptions = this.props.includeOptions ?
            Object.assign({}, updatedSpreadsheetOptions)
            :
            Object.assign(this.props.useOptions, {
                useXL: updatedSpreadsheetOptions.useXL,
                codepage: updatedSpreadsheetOptions.codepage,
                ignoreInvalidValues: updatedSpreadsheetOptions.ignoreInvalidValues,
                ignoreHeaderRow: updatedSpreadsheetOptions.ignoreHeaderRow
            });
        this.setState({ mapping, spreadsheetOptions, validSpreadsheet });
    };

    onSelectFile = (data) => {
        // The next line shouldn't be necessary
        if (data.length === 0 || data.length > 1) return;
        let isSpreadsheet = false;
        const name = data[0].name;
        if (name.includes('.csv') || name.includes('.tsv') || name.includes('.xlsx') || name.includes('.csv') || name.includes('.txt')) {
            isSpreadsheet = true;
        }
        this.setState({ filename: data[0].path, file: data[0], isSpreadsheet });
    };

    waitForCompletion = (msg) => {
        if (this.cancellable && this.cancellable.isCancelled()) return;
        const graph = getGraphFromProject(this.props.project);
        if (msg.graphIRI === graph) {
            this.setState({ completionMessage: true });
        }
    };

    uploadFile = async () => {
        const { file, mapping, spreadsheetOptions } = this.state;
        try {
            await file.slice(0, 1).arrayBuffer();
        }
        catch (e) {
            this.setState({
                isErrored: true,
                errorMessage: "Cannot access file. It may have changed. Please start again."
            });
            return;
        }
        let importContext = this.props.importContext;
        if (this.state.component && this.state.component !== undefined) {
            importContext = {
                situation: "AttachToDataset",
                resourceIRI: this.state.component,
                baseIRI: this.state.component
            };
        }

        let uploadMapping = {};
        if (spreadsheetOptions && Object.keys(spreadsheetOptions).length > 0) {
            uploadMapping.spreadsheetOptions = spreadsheetOptions;
            if (this.props.handleDuplicates) spreadsheetOptions.handleDuplicateLabels = true;
        }
        if (mapping && mapping.length > 0) uploadMapping.mapping = mapping;
        const optionsData = [
            {
                property: "https://grafsync.graphifi.com/schema/gs/useSlashIRI",
                value: this.props.useSlashIRI !== null && this.props.useSlashIRI !== undefined ?
                    this.props.useSlashIRI
                    :
                    this.state.slashHash === "Slash"
            },
            {
                property: "https://grafsync.graphifi.com/schema/gs/useUuidIRI",
                value: this.props.useUuidIRI !== null && this.props.useUuidIRI !== undefined ?
                    this.props.useUuidIRI
                    :
                    this.state.iriFormat === "UUID"
            },
            {
                property: "https://grafsync.graphifi.com/schema/gs/allowMinorIssues",
                value: this.props.issueManagement !== null && this.props.issueManagement !== undefined ?
                    this.state.allowMinorIssues
                    :
                    false
            }
        ];
        if (this.state.iriFormat === "Counter") {
            optionsData.push({
                property: "https://grafsync.graphifi.com/schema/gs/useCounterIRI",
                value: true
            });
            optionsData.push({
                property: "https://grafsync.graphifi.com/schema/gs/primaryCounter",
                value: this.state.primaryCounter - 1
            });
            optionsData.push({
                property: "https://grafsync.graphifi.com/schema/gs/secondaryCounter",
                value: this.state.secondaryCounter - 1
            });
        }
        if (this.props.importManagement && this.state.ignoreMissingImports !== "undefined") {
            optionsData.push({
                property: "https://grafsync.graphifi.com/schema/gs/ignoreMissingImports",
                value: this.state.ignoreMissingImports === "true"
            });
        }
        if (this.props.importApproachManagement) {
            optionsData.push({
                property: "https://grafsync.graphifi.com/schema/gs/importApproachIsDocument",
                value: this.state.importApproach === "Document"
            });
        }
        this.cancellable = makeCancelable(
            GS.upload(file, this.props.project, getGraphFromProject(this.props.project),
                optionsData,
                uploadMapping,
                importContext,
                this.waitForCompletion)
                .then(resp => {
                    if (this.cancellable && !this.cancellable.isCancelled()) {
                        this.setState({ uuid: resp.filename, uploaded: true });
                        this.watchUpload();
                    }
                })
                .catch((e) => {
                    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({
                        isErrored: true,
                        errorMessage: e.message
                    });
                })
        );
        return this.cancellable;
    };

    watchUpload = () => {
        if (this.hcTimeout) clearTimeout(this.hcTimeout);
        this.hcTimeout = setTimeout(async () => {
            try {
                let status = await GS.uploadStatus(this.state.uuid);
                if (this.cancellable && !this.cancellable.isCancelled()) {
                    this.setState({
                        ...(status.transfer !== undefined) && { transfer: status.transfer },
                        ...(status.normalisation) && { normalisation: status.normalisation },
                        ...(status.message) && { message: status.message },
                        ...(status.status) && { status: status.status },
                        ...(status.stepCount) && { stepCount: status.stepCount }
                    });
                    // Keep looping until ready
                    if (this.clickRef && this.clickRef.current) {
                        this.clickRef.current.click();
                    }
                    if (status.transfer === undefined) this.watchUpload();
                }
            }
            catch (e) {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                this.setState({
                    transfer: false,
                    isErrored: true,
                    errorMessage: e.message
                });
            }
        }, 2000);
    };

    getStepContent = (step) => {
        if (step === 2 && !this.state.uploaded) this.uploadFile();

        switch (step) {
            case 0:
                return <SelectFile
                    classes={this.props.classes}
                    additionalExtensions={this.props.additionalExtensions}
                    spreadsheetOnly={this.props.spreadsheetOnly}
                    filename={this.state.filename}
                    enableSpreadsheet={this.props.enableSpreadsheet}
                    onSelectFile={this.onSelectFile} />;
            case 1:
                return <SelectOptions
                    onBaseIRIChange={this.onBaseIRIChange}
                    classes={this.props.classes}
                    file={this.state.file}
                    maxRows={this.props.maxRows}
                    issueManagement={this.props.issueManagement}
                    importManagement={this.props.importManagement}
                    importApproachManagement={this.props.importApproachManagement}
                    importApproach={this.state.importApproach}
                    allowMinorIssues={this.state.allowMinorIssues}
                    ignoreMissingImports={this.state.ignoreMissingImports}
                    limits={this.props.spreadsheetOnly ? "partial" : null}
                    isSpreadsheet={this.state.isSpreadsheet}
                    useOptions={this.props.useOptions}
                    byIRI={this.props.byIRI}
                    allowCounter={this.props.allowCounter}
                    enabledImportInto={this.props.enabledImportInto}
                    configOptions={this.props.configOptions}
                    project={this.props.project}
                    xrefComponents={this.props.xrefComponents || []}
                    existingComponents={this.props.existingComponents || []}
                    includeOptions={this.props.includeOptions}
                    ontologyProjectAssociation={this.props.data ? this.props.data.ontologyProjectAssociation : null}
                    optionForXL={this.props.data ? this.props.data.skosXL : null}
                    optionForAddToComponent={this.props.data && this.props.data.type === "DataProject" ? true : false}
                    iriType={this.state.slashHash}
                    iriFormat={this.state.iriFormat}
                    primaryCounter={this.state.primaryCounter}
                    secondaryCounter={this.state.secondaryCounter}
                    component={this.state.component}
                    filename={this.state.filename}
                    mapping={this.state.mapping}
                    spreadsheetOptions={this.state.spreadsheetOptions}
                    onComponentSelect={this.onComponentSelect}
                    onUpdateMapping={this.onUpdateMapping}
                    onToggleMinorIssues={this.onToggleMinorIssues}
                    onToggleImportApproach={this.onToggleImportApproach}
                    onToggleMissingImports={this.onToggleMissingImports}
                    onSlashHashSelect={this.onSlashHashSelect}
                    onPrimaryCounterSet={this.onPrimaryCounterSet}
                    onSecondaryCounterSet={this.onSecondaryCounterSet}
                    onIRIformatSelect={this.onIRIformatSelect} />;
            case 2:
                return <Upload
                    message={this.state.message}
                    disableScreen={this.props.disableScreen}
                    transfer={this.state.transfer}
                    status={Array.isArray(this.state.status) ? this.state.status : [this.state.status]}
                    issueManagement={this.props.issueManagement}
                    importApproachManagement={this.props.importApproachManagement}
                    importManagement={this.props.importManagement}
                    importApproach={this.state.importApproach}
                    allowMinorIssues={this.state.allowMinorIssues}
                    ignoreMissingImports={this.state.ignoreMissingImports}
                    filename={this.state.filename}
                    stepCount={this.state.stepCount}
                    normalisation={this.state.normalisation} />;
            default:
                return 'Unknown step';
        }
    };

    canContinue = (step) => {
        if (step === 0 && this.state.filename === null) return false;
        if (step === 1 && this.state.isSpreadsheet && !this.state.validSpreadsheet) return false;
        if (step === 2 && this.state.transfer !== false && this.state.completionMessage === false) return false;
        if (step === 2 && this.state.transfer === null) return false;
        return true;
    };

    canGoBack = (step) => {
        if (step === 2 && this.state.transfer !== false) return false;
        return true;
    };

    handleReset = () => this.setState(Object.assign(stateReset));

    handleBack = () => this.setState({
        transfer: null,
        uploaded: false
    });

    onComplete = async () => {
        this.setState(Object.assign(stateReset));
        // We need to force a reload because loaded resources may have been impacted
        await GS.unload();
        // We reload the project to make sure it is loaded
        const project = this.props.project;
        await GS.loadData([project], {}, getGraphFromProject(project));
        let link = this.props.baseLink + '#project=' + project;
        if (this.props.subLink) {
            link += "&" + this.props.subLink;
        }
        this.props.history.push(link);
    };

    onExitWarning = () => this.setState(Object.assign(stateReset));

    render() {

        const { isErrored, errorMessage, transfer, isSpreadsheet } = this.state;
        const { classes, importUnavailable, center } = this.props;

        if (isErrored) return <Warning message={errorMessage} onExitWarning={this.onExitWarning} />;

        return (
            <div className={classes.import} ref={this.clickRef} style={{
                ...(!isSpreadsheet) && { maxWidth: '743px' },
                ...(center) && {
                    marginLeft: 'auto',
                    marginRight: 'auto'
                },
                ...(!center) && {
                    marginRight: 30
                }
            }}>
                <ImportStepper
                    importUnavailable={importUnavailable}
                    steps={steps}
                    getStepContent={this.getStepContent}
                    title="Import data"
                    errored={transfer === false}
                    canGoBack={this.canGoBack}
                    canContinue={this.canContinue}
                    handleReset={this.handleReset}
                    handleBack={this.handleBack}
                    onError={this.onExitWarning}
                    onComplete={this.onComplete} />
            </div>
        );
    }
}

ProjectImport.defaultProps = {
    importUnavailable: null,
    disableScreen: false,
    includeOptions: true,
    enabledImportInto: false,
    enableSpreadsheet: false,
    issueManagement: false,
    importManagement: false,
    importApproachManagement: false,
    handleDuplicates: false
};

ProjectImport.propTypes = {
    importContext: PropTypes.object,
    additionalExtensions: PropTypes.array,
    classes: PropTypes.object,
    data: PropTypes.object,
    maxRows: PropTypes.number,
    subLink: PropTypes.string,
    center: PropTypes.bool,
    xrefComponents: PropTypes.array,
    spreadsheetOnly: PropTypes.bool,
    includeOptions: PropTypes.bool,
    useSlashIRI: PropTypes.bool,
    handleDuplicates: PropTypes.bool,
    enabledImportInto: PropTypes.bool,
    useUuidIRI: PropTypes.bool,
    useCounterIRI: PropTypes.bool,
    disableScreen: PropTypes.bool,
    history: PropTypes.object,
    existingComponents: PropTypes.array,
    useOptions: PropTypes.object,
    project: PropTypes.string.isRequired,
    importUnavailable: PropTypes.string,
    enableSpreadsheet: PropTypes.bool,
    issueManagement: PropTypes.bool,
    importApproachManagement: PropTypes.bool,
    importApproch: PropTypes.string,
    baseLink: PropTypes.string.isRequired
};

SelectOptions.propTypes = {
    classes: PropTypes.object,
    issueManagement: PropTypes.bool,
    importApproachManagement: PropTypes.bool,
    importApproch: PropTypes.string,
    onToggleMinorIssues: PropTypes.func,
    onToggleImportApproach: PropTypes.func,
    onToggleMissingImports: PropTypes.func,
    onSlashHashSelect: PropTypes.func,
    onIRIformatSelect: PropTypes.func,
    onPrimaryCounterSet: PropTypes.func,
    onSecondaryCounterSet: PropTypes.func,
    onUpdateMapping: PropTypes.func,
    mapping: PropTypes.array,
    xrefComponents: PropTypes.array,
    allowMinorIssues: PropTypes.bool,
    importApproach: PropTypes.string,
    ignoreMissingImports: PropTypes.string,
    onBaseIRIChange: PropTypes.func,
    spreadsheetOptions: PropTypes.object,
    iriFormat: PropTypes.string,
    isSpreadsheet: PropTypes.bool,
    byIRI: PropTypes.bool,
    includeOptions: PropTypes.bool,
    maxRows: PropTypes.number,
    enabledImportInto: PropTypes.bool,
    allowCounter: PropTypes.bool,
    data: PropTypes.object,
    primaryCounter: PropTypes.number,
    secondaryCounter: PropTypes.number,
    onComponentSelect: PropTypes.func,
    ontologyProjectAssociation: PropTypes.array,
    configOptions: PropTypes.string,
    filename: PropTypes.string,
    file: PropTypes.object,
    lang: PropTypes.string,
    existingComponents: PropTypes.array,
    project: PropTypes.string,
    limits: PropTypes.string,
    onSpreadsheetLangSelect: PropTypes.func,
    optionForXL: PropTypes.bool,
    isValidIRI: PropTypes.bool,
    sheetData: PropTypes.object,
    iriType: PropTypes.string,
    baseIRI: PropTypes.string
};

export default withRouter(withStyles(styles)(ProjectImport));